<template>
  <div style="min-height: 92vh">
    <div>
      <h3>Almacenes</h3>
      <uv-data-table
        :config="config"
        :data="global_origen"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>
    <modal v-model="showModal" :showFooter="false" title="Centros de consumo">
      <invResForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      >
      </invResForm>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import invResForm from "../invResources/invResForm.vue";

export default {
  name: "ServiciosCrud",
  components: {
    modal,
    uvDataTable,
    invResForm,
  },
  props: [],
  data() {
    return {
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      editData: [],
      origenes: [],
      config: {
        selectableRow: true,
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "agregarInv",
            require: false,
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editInv",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteInv",
            require: true,
          },
        ],
        fields: [
          {
            text: "Nombre",
            value: "Nombre",
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "agregarInv") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};

        this.toggleModal(true);
      }
      if (buttonId == "editInv") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.getOrigenById(idSelected[0]);
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
      if (buttonId == "deleteInv") {
        this.deleteOrigen(idSelected[0]);
      }
    },
    deleteOrigen(id) {
      let datos = { Id: id };
      this.$swal({
        title: "¿Deseas eliminar el Centros de consumo?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Inventario-deleteOrigen", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "El origen se elimino correctamente",
              "El origen se elimino correctamente",
              "success"
            );
            this.$store.dispatch("getOrigenes");
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },

    successData(data) {
      data.Departamentos = {};
      if (data.modProshop) {
        data.Departamentos.ProShop = true;
      }
      if (data.modClubPlaya) {
        data.Departamentos.ClubPlaya = true;
      }
      if (data.modRestaurante) {
        data.Departamentos.Restaurante = true;
      }
      if (data.Id == "") {
        this.createInvResource(data);
      } else {
        this.editInvResource(data);
      }

      //this.editProduct(data);
    },
    createInvResource(datos) {
      this.$swal({
        title: "¿Deseas agregar este nuevo inventario recurso?",
        text: "Podras editarlo y modificarlo cuando quieras",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Agregar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Inventario-createOrigen", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          // this.$emit('reloadClient');
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "El inventario recurso se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.$store.dispatch("getOrigenes");
            });
          } else {
            this.$swal(
              "Error saving inventario",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editInvResource(datos) {
      this.$swal({
        title: "¿Deseas editar este Centros de consumo?",
        text: "Los cambios se veran reflejados inmediatamente",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Inventario-updateOrigen", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "El producto se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.$store.dispatch("getOrigenes");
            });
          } else {
            this.$swal(
              "Error saving Categoria",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    toggleModal(open) {
      this.showModal = open;
    },

    getOrigenById(code) {
      let itemIndex = this.$_.findIndex(this.global_origen, { id: code });
      if (itemIndex >= 0) {
        return this.global_origen[itemIndex];
      }

      return false;
    },
  },
  computed: {
    global_origen() {
      let ori = this.$store.getters.getCentrosConsumo;
      /*prod.forEach((element)=>{
            element.categoria_name = this.getCategoryById(element.Categoria).Nombre;
        })*/
      return ori;
    },
  },
  watch: {},
  mounted() {},
  created() {},
};
</script>
